import React from 'react';
import './../../core/style/GuidanceSection.css';

const GuidanceSection = ({ videoId = "uoiyNzi_z28" }) => {
    return (
        <section className="guidance-container" id="guidance">
            <div className="guidance-content">
                <div className="guidance-text">
                    <h2 className="reveal-text">Guidance & Support</h2>
                    <div className="industrial-divider"></div>
                    <p>
                        Access our comprehensive video tutorials for technical insights
                        on Busan hydraulic rock breakers, JCB breakers, and excavator attachments.
                    </p>
                </div>

                <div className="video-window">
                    <div className="video-chrome">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div>
                    <div className="video-responsive">
                        <iframe
                            src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1`}
                            title="Busan Guidance Video"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            referrerPolicy="strict-origin-when-cross-origin"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default GuidanceSection;